import $ from 'jquery'
import 'jquery.transit'   // needed for notify.tsx:84
import 'trumbowyg'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import trumbowygIcons from 'trumbowyg/dist/ui/icons.svg'

import './jqext'  // must be at below other imports

globalThis.$ = globalThis.jQuery = $
$.trumbowyg.svgPath = trumbowygIcons

export default $
